import { EbrService } from 'src/app/core/services/ebr.service';
import { Filters } from 'src/app/global/filter-model';
import { Component, OnInit, Input } from '@angular/core';
import { MixpanelService } from '../../../../core/services/mixpanel.service';
import { AlertService } from '../../../../core/services/alert.service';
import { Alert } from '../../../../global/types';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { SpreadsheetService } from 'src/app/core/services/spreadsheet.service';
import { Subscription } from 'rxjs';
import { FiltersService } from 'src/app/core/services/filters.service';
import { Division } from 'src/app/core/services/ebr-api-client/ebr-api-client.g';
import { DownloadStatus } from 'src/app/shared/types/download-button-types';

@Component({
    selector: 'download-spreadsheet-button',
    templateUrl: './download-spreadsheet-button.component.html',
    styleUrls: ['./download-spreadsheet-button.component.css'],
    standalone: false
})
export class DownloadSpreadsheetButtonComponent implements OnInit {
  @Input() disabled: boolean = false; // TODO: Is this needed anymore as an input or can it be derived from the filters/feature flag.

  downloadSpreadsheetStatusSubscription: Subscription | undefined;

  buttonText: string | undefined;
  downloadSpreadSheetStatus: DownloadStatus = DownloadStatus.Idle;
  DownloadSpreadsheetStatusEnum = DownloadStatus;
  filters: ContractModel | undefined;
  disableSpreadsheetDownload: boolean = false;

  constructor(
    private ebrService: EbrService,
    private alertService: AlertService,
    private mixpanelService: MixpanelService,
    private spreadsheetService: SpreadsheetService,
    private filtersService: FiltersService,
  ) {}

  // HACK: To maintain consistent button width based on the longest possible text, we use an invisible span.
  get longestButtonText(): string {
    return this.spreadsheetService.resolveLongestButtonText(
      this.filters?.division as Division
    );
  }

  ngOnInit(): void {
    this.filtersService.selectedFiltersObservable.subscribe((data) => {
      this.filters = data;
    });

    this.downloadSpreadsheetStatusSubscription =
      this.spreadsheetService.downloadStatus$.subscribe((status) => {
        this.downloadSpreadSheetStatus = status;
        this.buttonText =
          this.spreadsheetService.resolveSpreadsheetDownloadButtonText(
            status,
            this.filters?.division as Division,
          );
      });
  }

  ngOnDestroy(): void {
    this.downloadSpreadsheetStatusSubscription?.unsubscribe();
  }

  async onDownloadSpreadsheet() {
    this._trackDownload('Download Spreadsheet Clicked');
    if (!this.disableSpreadsheetDownload) {
      if (this.filters != undefined) {
        this.mixpanelService.time_event('Spreadsheet Download started');
        this.disableSpreadsheetDownload = true;
        this.spreadsheetService.updateSpreadsheetDownloadStatus(
          DownloadStatus.Running,
        );

        let initializeDownload = true;
        const fileData = await this.ebrService
          .getExcelReport(this.filters)
          .then((response) => {
            const { data } = response;
            return data;
          })
          .catch((error) => {
            initializeDownload = false;
            this.alertService.addAlert(this.createErrorAlert());
            console.log(JSON.stringify(error));
          });

        if (initializeDownload) {
          this.executeBrowserDownload(fileData);
        }

        this.disableSpreadsheetDownload = false;
        this._trackDownload('Spreadsheet Download started');
        this.spreadsheetService.updateSpreadsheetDownloadStatus(
          DownloadStatus.Idle,
        );
      }
    }
  }

  createErrorAlert(): Alert {
    const id = Math.random() * 25;
    const message =
      'The excel download has encountered an error. Please try again.';
    return { id: id, message: message };
  }

  executeBrowserDownload(fileData: BlobPart) {
    const url = window.URL.createObjectURL(new Blob([fileData]));
    const link = document.createElement('a');
    link.href = encodeURI(url);
    link.setAttribute('download', 'EBR-data-' + new Date() + '.xlsx');
    document.body.appendChild(link);
    link.click();
  }

  private _trackDownload(eventName: string): void {
    this.mixpanelService.track(eventName, {
      divisionSelected: this.filters?.division,
      regionSelected: this.filters?.regions,
      countriesSelected: this.filters?.countries,
      H5s: this.filters?.topLevelContractGroup,
      H7s: this.filters?.secondLevelContractFilter,
      customerNumbersSelected: this.filters?.accts,
      periodSelected: this.filters?.period,
      'Custom Date Range': this.filters?.dateRange,
      templateSelected: this.filters?.presentationType,
    });
  }
}
